import React, { useState } from "react"
import { Flex, Link, useAuthenticator } from "@aws-amplify/ui-react"
import { useConfig } from "../../configuration/useConfig"
import { GOOGLE_ISS } from "../../configuration/config"
import IdpSignInButton from "./IdpSignInButton"
import GoogleSignInButton from "./GoogleSignInButton"

const SignInFooter = () => {
  const { toForgotPassword } = useAuthenticator()
  const {config} = useConfig()
  const [error, setError] = useState<string | null>(null)

  const googleProvider = config.idpProviders.find((p) => p.iss === GOOGLE_ISS)
  const customProviders = config.idpProviders.filter((p) => p.iss !== GOOGLE_ISS)

  return (
    <Flex direction="column" gap={"0.75rem"}>
      {googleProvider && (
        <GoogleSignInButton setError={setError} />
      )}
      {customProviders.map(provider => {
        return (
          <IdpSignInButton providerName={provider.name} setError={setError} key={provider.name}></IdpSignInButton>
      )})}
      {error ? (
        <span style={{ color: "#fff", fontSize: "0.9rem" }}>{error}</span>
      ) : null}
      <Link onClick={toForgotPassword}>Forgot your password?</Link>
    </Flex>
  )
}

export default SignInFooter
